import React from 'react';
import { useTranslation } from 'react-i18next';
import { Section, SectionSubTitle, Typography } from 'common/components';
import { createElementKey } from 'utils';
import { BENEFITS_SECTION_DATA, BenefitSectionDataStructure } from './benefits-section-constants';
import { benefitsItem, Grid, sectionSubtitleStyle } from './benefits-section-styles';

/**
 * Вью секции асортимента преимущества
 */
export const BenefitsSection = ({ isRuRegion }: { isRuRegion: boolean; }) => {
  const { t } = useTranslation();

  return (
    <Section>
      <SectionSubTitle className={sectionSubtitleStyle} margin="l">
        {t('benefits-section.title')}
      </SectionSubTitle>
      <Grid>
        {BENEFITS_SECTION_DATA.map(
          ({ icon, text = '', textFormatter }: BenefitSectionDataStructure, index: number) => (
            <div className={benefitsItem} key={createElementKey('benefits', index)}>
              {icon}
              <Typography adaptive={false} size="body_short" variant="m">
                {textFormatter ? textFormatter(t, isRuRegion) : t(text)}
              </Typography>
            </div>
          )
        )}
      </Grid>
    </Section>
  );
};
